import { SettingsParser } from "./settings-parser";
import { VisualizatorSettingsArray } from "../settings/visualizator-settings-array";

export class SettingsArrayParser extends SettingsParser {
  constructor(itemParser) {
    super();
    this.itemParser = itemParser;
  }

  static createSettings(settings, defaultSettings, itemParser) {
    if (settings === undefined || !Array.isArray(settings) || itemParser === undefined) {
      return undefined;
    }
    let parsedSettings = [];
    for (let itemIndex = 0; itemIndex < settings.length; itemIndex++) {
      let parsedItem = itemParser.parse(settings[itemIndex], defaultSettings);
      if (parsedItem !== undefined) {
        parsedSettings.push(parsedItem);
      }
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = SettingsArrayParser.createSettings(settings, defaultSettings, this.itemParser);
    if (parsedSettings === undefined) {
      return undefined;
    }
    return new VisualizatorSettingsArray(parsedSettings);
  }
}
